import { render, staticRenderFns } from "./HeaderNavigation.vue?vue&type=template&id=23ac4ca9&scoped=true&"
import script from "./HeaderNavigation.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNavigation.vue?vue&type=style&index=0&id=23ac4ca9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac4ca9",
  null
  
)

export default component.exports